import React from 'react';
import { notification } from 'antd';
import { connect } from 'react-redux';

class Notification extends React.Component {
  componentWillReceiveProps(nextProps) {
    const { title, message } = nextProps;
    notification.open({ message: title, description: message });
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return <div />;
  }
}

function mapStateToProps({ sistemaNotificaciones: { title, message, timestamp } }) {
  return {
    title,
    message,
    timestamp,
  };
}
export default connect(mapStateToProps, null)(Notification);
